/* Cellar Atlas – consolidated Mailchimp form helpers
   - Works for both Newsletter and Partner forms
   - No dependencies; mc-validate.js can still be loaded separately
*/
(function () {
  // Prevent double init (Shopify sections can re-render)
  if (window.__caMailchimpInit) return;
  window.__caMailchimpInit = true;

  // ---- Mailchimp field map (union of all forms) ----
  // Mailchimp's mc-validate.js expects these globals when present.
  window.fnames = window.fnames || [];
  window.ftypes = window.ftypes || [];
  var map = [
    [1,  'FNAME',     'text'],
    [2,  'LNAME',     'text'],
    [0,  'EMAIL',     'email'],
    [4,  'PHONE',     'phone'],
    [6,  'COMPANY',   'text'],
    [11, 'TYPEBUSS',  'dropdown'],
    [12, 'BUSSNOTES', 'text'],
    [13, 'COUNTRY',   'dropdown'],  // Added Business Country dropdown
    [7,  'MMERGE7',   'dropdown'],
    [8,  'MMERGE8',   'dropdown'],
    [9,  'MMERGE9',   'dropdown'],
    [10, 'MMERGE10',  'dropdown']
  ];
  for (var i = 0; i < map.length; i++) {
    var idx = map[i][0], name = map[i][1], type = map[i][2];
    window.fnames[idx] = name;
    window.ftypes[idx] = type;
  }

  // ---- Smooth scroll fallback (CSS scroll-behavior already handles most) ----
  function bindSmoothScroll(id) {
    var anchors = document.querySelectorAll('a[href="#' + id + '"]');
    anchors.forEach(function(a){
      a.addEventListener('click', function(e){
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        if (target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.location.hash = id;
        }
      });
    });
  }
  ['newsletter-signup', 'partners-signup'].forEach(bindSmoothScroll);

  // ---- Partner form: BUSSNOTES character limit + counter ----
  function setupNotesCounter() {
    var notes = document.getElementById('mce-BUSSNOTES');
    if (!notes) return;

    var MAX = 200;
    if (!notes.hasAttribute('maxlength')) notes.setAttribute('maxlength', String(MAX));

    var counter = document.getElementById('notes-count');
    if (!counter) {
      counter = document.createElement('p');
      counter.id = 'notes-count';
      counter.className = 'ca-help';
      counter.style.marginTop = '0.25rem';
      notes.parentNode.appendChild(counter);
    }

    function renderCount() {
      var remaining = MAX - (notes.value || '').length;
      counter.textContent = 'You can enter ' + remaining + ' characters remaining (max ' + MAX + ').';
    }
    renderCount();

    notes.addEventListener('input', renderCount);
  }

  // ---- Normalize phone input UX ----
  function setupPhoneField() {
    var tel = document.getElementById('mce-PHONE');
    if (!tel) return;
    if (!tel.getAttribute('inputmode')) tel.setAttribute('inputmode', 'tel');
    if (!tel.getAttribute('autocomplete')) tel.setAttribute('autocomplete', 'tel');
  }

  // ---- DOM ready helper ----
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function(){
    setupNotesCounter();
    setupPhoneField();
  });
})();
